const en = {
  // Discount status
  stateDisabled: "Disabled",
  stateExpired: "Expired",
  stateUsedUp: "Used up",
  stateScheduled: "Scheduled",
  stateActive: "Active",

  // Discounts list
  discountsTitle: "Discounts",
  discountsDescription: "Codes customers enter at checkout. One code per order — codes never stack.",
  createDiscount: "Create discount",
  notInPlan: "Discount codes aren't included in your current plan. Upgrade to create them.",
  discountDeleted: "Discount deleted.",
  noDiscounts: "No discount codes yet",
  noDiscountsHint: "Create a code like WELCOME10 to reward newsletter sign-ups or run a sale.",
  colCode: "Code",
  colValue: "Value",
  colUsed: "Used",
  colWindow: "Active window",
  percentOff: "{value}% off",
  amountOff: "{amount} off",
  freeShipping: "Free shipping",
  entireOrder: "Entire order",
  productsCount: "{count} products",
  productsCount_one: "{count} product",
  collectionsCount: "{count} collections",
  collectionsCount_one: "{count} collection",
  minSubtotalShort: "min {amount}",
  perCustomer: "{count} per customer",
  now: "Now",
  noEnd: "No end",

  // Discount edit page
  editDiscount: "Edit discount",
  newBreadcrumb: "New",
  usedTimes: "Used {count} times",
  usedTimes_one: "Used {count} time",
  deleteTitle: "Delete {code}?",
  deleteUsedBody: "This code has been used on orders, so it will be deactivated instead of deleted to keep order history accurate.",
  deleteBody: "The code is permanently deleted. Customers can no longer use it.",
  discountCreated: "Discount created. Share the code {code} with your customers.",

  // Discount actions
  percentRange: "Enter a percentage between 0.01 and 100.",
  percentRangeField: "Enter a percentage between 0.01 and 100",
  enterDiscountAmount: "Enter the discount amount.",
  enterAmount: "Enter an amount",
  invalidStart: "Enter a valid start date.",
  invalidEnd: "Enter a valid end date.",
  invalidDate: "Invalid date",
  discountSaved: "Discount saved.",
  deactivatedInstead: "This code has already been used on orders, so it was deactivated instead of deleted (kept for order history and reports).",

  // Discount editor
  codeDescription: "Customers enter this at checkout. Only one discount code can be used per order — codes don't stack.",
  discountCode: "Discount code",
  codeHint: "3–32 letters, numbers, - or _. Not case-sensitive.",
  generate: "Generate",
  internalTitle: "Internal title",
  internalTitleHint: "Only you see this, e.g. “Newsletter welcome”.",
  discountType: "Discount type",
  kindPercentage: "Percentage",
  kindPercentageHint: "e.g. 10% off",
  kindFixed: "Fixed amount",
  kindFixedHint: "e.g. 5.00 {currency} off",
  kindFreeShippingHint: "Removes shipping cost",
  percentageOff: "Percentage off",
  amountOffLabel: "Amount off",
  amountOffHint: "Taken off the eligible items, never more than their total.",
  appliesTo: "Applies to",
  specificProducts: "Specific products",
  specificCollections: "Specific collections",
  pickProductsEmpty: "Search above to choose products.",
  noCollections: "You don't have any collections yet.",
  freeShippingEligible: "Free shipping applies when the cart contains an eligible item.",
  requirements: "Requirements & limits",
  minSubtotal: "Minimum subtotal",
  totalUses: "Total uses",
  usedSoFar: "Used {count} times so far.",
  usedSoFar_one: "Used {count} time so far.",
  unlimitedHint: "Leave empty for unlimited.",
  usesPerCustomer: "Uses per customer",
  perCustomerHint: "Counted by email address.",
  statusSchedule: "Status & schedule",
  timezoneHint: "Times are in the store timezone ({timezone}).",
  activeHint: "Turn off to pause the code without deleting it.",
  starts: "Starts",
  startsHint: "Empty = immediately.",
  ends: "Ends",
  endsHint: "Empty = never expires.",

  // Marketing page
  marketingTitle: "Marketing",
  marketingDescription: "Win back shoppers and grow your mailing list.",
  abandonedReminders: "Abandoned cart reminders",
  paidPlans: "Paid plans",
  on: "On",
  off: "Off",
  abandonedInfo: "Sends one email reminder to a shopper who left items in their cart. Reminders are only sent to shoppers who gave marketing consent at checkout, at most once per cart, and every email includes an unsubscribe link.",
  abandonedNotInPlan: "Abandoned-cart reminders aren't included in the {plan} plan. {upgrade} to turn them on.",
  upgrade: "Upgrade",
  sendAbandoned: "Send abandoned cart reminders",
  delayLabel: "Send the reminder after (hours)",
  delayHint: "Between 1 and 72 hours of cart inactivity.",
  newsletterSignup: "Newsletter signup",
  newsletterLabel: "Show a newsletter signup form on your storefront",
  newsletterHint: "Visitors who sign up are added to your subscriber list with their consent date. You send campaigns with your own email tool.",
  saveMarketing: "Save marketing settings",
  marketingSaved: "Marketing settings saved",
  subscribers: "Subscribers",
  activeSubscribers: "{n} active subscribers",
  activeSubscribers_one: "{n} active subscriber",
  exportCsv: "Export CSV",
  noSubscribers: "No subscribers yet",
  noSubscribersHint: "People who sign up for your newsletter or opt in to marketing at checkout will appear here.",
  colSource: "Source",
  colSubscribed: "Subscribed",
  sourceStorefront: "Storefront",
  sourceCheckout: "Checkout",
  showing100: "Showing the 100 most recent. Export the CSV for the full list.",
  abandonedLast30: "Abandoned carts · last 30 days",
  abandoned: "Abandoned",
  abandonedDef: "Carts with items, inactive for over an hour and not checked out.",
  withEmail: "With email",
  withEmailDef: "Abandoned carts where the shopper entered an email address.",
  reminded: "Reminded",
  remindedDef: "Carts that received a reminder email.",
  recovered: "Recovered",
  recoveredDef: "Reminded carts that later became an order.",
  moreWays: "More ways to grow",
  discountsHint: "Codes and automatic offers",
  seo: "SEO & redirects",
  seoHint: "Sitemap and URL redirects",
  analytics: "Analytics",
  analyticsHint: "Sales, funnel and top products",

  // Analytics
  analyticsDescription: "Sales performance in {currency}. Test-mode orders are always excluded.",
  rangeToday: "Today",
  range7d: "7d",
  range30d: "30d",
  range90d: "90d",
  range12m: "12m",
  keyFigures: "Key figures",
  netSales: "Net sales",
  grossSales: "Gross sales",
  discounts: "Discounts",
  discountsDef: "Discount totals on paid orders in this period (including free-shipping discounts).",
  refunds: "Refunds",
  paidOrders: "Paid orders",
  aov: "Avg. order value",
  totalCollected: "Total collected",
  afterRefunds: "{amount} after refunds",
  pendingPayment: "Pending payment",
  pendingSub: "{count} orders · not received",
  pendingSub_one: "{count} order · not received",
  shippingCharged: "Shipping charged",
  shippingDef: "Shipping charged on paid orders.",
  taxCharged: "Tax charged",
  taxDef: "Tax on paid orders (whether included in prices or added at checkout). You are responsible for remitting it.",
  customers: "Customers",
  repeatCustomers: "Repeat customers",
  repeatSub: "{repeat} of {total} (all time)",
  defPaidOrders: "Orders with a confirmed payment (paid, partially refunded, refunded or disputed) placed in this period. Test-mode orders are excluded.",
  defGross: "Sum of item subtotals before discounts, for orders with a confirmed payment. Excludes shipping and tax-only amounts. Test-mode orders excluded.",
  defNet: "Net sales = gross sales − discounts − refunds issued in this period. Test-mode orders excluded.",
  defAov: "Average order value = (gross sales − discounts) ÷ paid orders.",
  defPending: "Total of open orders still awaiting payment (e.g. bank transfer, cash on delivery, unfinished online payments). This money has NOT been received.",
  defRefunds: "Refunds that succeeded in this period, regardless of when the order was placed.",
  defCollected: "Amounts captured by your payment providers or marked as received for offline payments, before refunds. Provider fees are not included because they are charged by your provider.",
  defCustomers: "Distinct customer emails with a paid order in this period.",
  defRepeat: "Customers (all time) with more than one paid order, out of all customers with a paid order.",
  howCalculated: "How these numbers are calculated",
  averageOrderValue: "Average order value",
  grossMargin: "Gross margin",
  grossMarginDef: "Revenue minus cost, only for items where you entered a cost price. Shown as “—” when no cost is known.",
  feesProfit: "Fees and profit",
  feesProfitDef: "Payment processing fees are charged by your own provider and aren't visible to the platform, so profit after fees isn't calculated.",
  salesByDay: "Sales by day",
  salesByDayHint: "Net of discounts, paid orders, by order date (UTC days).",
  noPaidOrders: "No paid orders in this period.",
  advancedAnalytics: "Advanced analytics",
  advancedHint: "Top products with margins, payment status breakdown, the conversion funnel and abandoned-cart statistics are included in Growth and Scale plans.",
  seePlans: "See plans",
  askOwner: "Ask the store owner about upgrading.",
  topProducts: "Top products",
  topProductsHint: "By revenue (net of item discounts) on paid orders.",
  noSales: "No sales in this period",
  colProduct: "Product",
  colUnits: "Units",
  colRevenue: "Revenue",
  noCostPrice: "No cost price entered",
  paymentStatus: "Payment status",
  paymentStatusHint: "All live orders placed in this period.",
  noOrdersPeriod: "No orders in this period",
  funnel: "Conversion funnel",
  funnelHint: "Unique visitors at each step.",
  visitors: "Visitors",
  viewedProduct: "Viewed a product",
  addedToCart: "Added to cart",
  startedCheckout: "Started checkout",
  placedOrder: "Placed an order",
  funnelNote: "Only visits recorded by the storefront's own tracking script are counted. Visitors who block scripts aren't included, so real traffic may be higher. Test orders may appear in “Placed an order”.",
  abandonedCarts: "Abandoned carts",
  abandonedCartsDef: "Carts with items, inactive for over an hour, last updated in this period and not checked out.",
  withEmailDefShort: "Abandoned carts where the shopper entered an email.",
  remindersSent: "Reminders sent",
  remindersSentDef: "Abandoned carts that received a reminder email (consenting shoppers only).",
  recoveredDefLong: "Reminded carts that later converted into an order.",
  feesAlert: "Payment-processing fees are charged by your own payment provider and aren't included. Check your provider's dashboard for payouts.",
};

export default en;
